import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../rootReducer";
import { AppStripId } from "@/components/AppStrip/appStripTypes";
import { getAppStripIdFromPath } from "@/utils/getAppStripIdFromPath";

interface AppStripState {
  /** Currently active app in the strip */
  activeApp: AppStripId | null;
}

const initialState: AppStripState = {
  activeApp: getAppStripIdFromPath(window.location.pathname) ?? "resources",
};

const appStripSlice = createSlice({
  name: "appStrip",
  initialState,
  reducers: {
    setActiveApp: (state, action: PayloadAction<AppStripId | null>) => {
      state.activeApp = action.payload;
    },
  },
});

export const { setActiveApp } = appStripSlice.actions;

export const selectActiveApp = (state: RootState) => state.appStrip.activeApp;

export default appStripSlice.reducer;
